/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep } from 'lodash';

// Components
import Badge from 'shared/ui/components/Badge.vue';
import BaseControl from './BaseControl.vue';
import MetaForm from 'shared/ui/components/form-components/MetaForm.vue';

const __vue_script__ = {
    name: 'NestedControl',

    components: { Badge, MetaForm },

    extends: BaseControl,

    props: {
        event: {
            type: Object,
            default: () => ({})
        },

        value: {
            type: Object,
            default: () => ({})
        },

        fields: {
            type: [Object, Array],
            required: true
        },

        skipSave: {
            type: Boolean,
            default: false
        },

        title: {
            type: String,
            default: null
        },

        badge: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        let nestedFields = [];
        if (this.fields instanceof Array) {
            nestedFields = this.fields;
        } else {
            for (const fieldName of Object.keys(this.fields)) {
                const fieldDescriptor = this.fields[fieldName];
                fieldDescriptor.field = fieldName;
                nestedFields.push(fieldDescriptor);
            }
        }

        const innerValue = cloneDeep(this.value);

        return { nestedFields, innerValue, saveHook: null };
    },

    computed: {
        badgeValue() {
            if (!this.badge || Object.keys(this.badge).length === 0) {
                return null;
            }

            const value = this.innerValue?.[this.badge.path];
            return this.badge.map[value];
        },

        badgeText() {
            const label = this.badgeValue?.label;
            if (typeof label === 'object') {
                const { path, map } = label;
                const value = this.innerValue[path];
                return map && map[value] ? map[value] : value;
            }

            return label;
        },

        badgeClass() {
            return this.badgeValue?.class;
        }
    },

    methods: {
        openEditor() {
            this.$modal.show(`nested-${this.uid}`);
        },

        triggerValidation() {
            if (this.skipSave) {
                this.$refs.form.validate();
            } else {
                this.saveHook = Date.now();
            }
        },

        save(value) {
            this.innerValue = value;
            this.$emit('input', this.innerValue);
            this.$modal.hide(`nested-${this.uid}`);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "control-decorator",
    {
      staticClass: "nested-control",
      attrs: {
        tip: _vm.tip,
        hint: _vm.hint,
        errors: _vm.errors,
        uid: _vm.uid,
        "hint-after-label": true,
        dependant: _vm.dependant,
      },
    },
    [
      _vm.title ? _c("h5", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "label" },
          [
            _c("span", [_vm._v(_vm._s(_vm.label))]),
            _vm.badgeText
              ? _c("badge", { class: _vm.badgeClass }, [
                  _vm._v(_vm._s(_vm.badgeText)),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c(
          "a",
          { staticClass: "btn", on: { click: _vm.openEditor } },
          [
            _c("i18n", { attrs: { path: "generic_form.types.nested" } }, [
              _c("strong", [_vm._v(_vm._s(_vm.label))]),
            ]),
          ],
          1
        ),
      ]),
      _c("modal", { attrs: { name: "nested-" + _vm.uid, height: "auto" } }, [
        _c("div", { staticClass: "modal-wrapper nested-form" }, [
          _vm.label
            ? _c("div", { staticClass: "modal-header" }, [
                _c("span", {
                  staticClass: "close",
                  on: {
                    click: function () {
                      return _vm.$modal.hide("nested-" + _vm.uid)
                    },
                  },
                }),
                _c(
                  "h3",
                  [
                    _c(
                      "i18n",
                      {
                        attrs: { path: "generic_form.contextual.nested.title" },
                      },
                      [_c("em", [_vm._v(_vm._s(_vm.label))])]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c("meta-form", {
                ref: "form",
                attrs: {
                  event: _vm.event,
                  fields: _vm.nestedFields,
                  "save-hook": _vm.saveHook,
                },
                on: { valid: _vm.save },
                model: {
                  value: _vm.innerValue,
                  callback: function ($$v) {
                    _vm.innerValue = $$v
                  },
                  expression: "innerValue",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-primary",
                on: { click: _vm.triggerValidation },
              },
              [_vm._v(_vm._s(_vm.$t("general.close")))]
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/NestedControl.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__